<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M13.3333 3.33325H14.1667C15.0871 3.33325 15.8333 4.07944 15.8333 4.99992V16.6666C15.8333 17.5871 15.0871 18.3333 14.1667 18.3333H5.83333C4.91286 18.3333 4.16667 17.5871 4.16667 16.6666V4.99992C4.16667 4.07944 4.91286 3.33325 5.83333 3.33325H6.66667"
			:stroke="color"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M7.5 2.5C7.5 2.03976 7.8731 1.66666 8.33333 1.66666H11.6667C12.1269 1.66666 12.5 2.03976 12.5 2.5V4.16666C12.5 4.6269 12.1269 5 11.6667 5H8.33333C7.8731 5 7.5 4.6269 7.5 4.16666V2.5Z"
			:stroke="color"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M7.5 8.33325H7.50833"
			:stroke="color"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
		/>
		<path
			d="M10 8.33325H12.5"
			:stroke="color"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
		/>
		<path
			d="M7.5 11.6667H7.50833"
			:stroke="color"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
		/>
		<path
			d="M10 11.6667H12.5"
			:stroke="color"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
		/>
		<path
			d="M7.5 15H7.50833"
			:stroke="color"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
		/>
		<path
			d="M10 15H12.5"
			:stroke="color"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconClipboard',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.65
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	}
}
</script>
